import React, { useContext } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';

import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useBatchTypeService from '../../../app/services/hooks/useBatchTypeService';

interface Props {
    batchTypeId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const BatchTypeSwitchChange = ({ batchTypeId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeBatchType, fetchingActiveBatchType } = useBatchTypeService();

    const active = (value: boolean) => {
        setChecked(value);

        activeBatchType(batchTypeId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={batchTypeId} callback={active} />;
};

export default BatchTypeSwitchChange;
